import {PushEvent} from './googleTagManager';
import {open} from './popupWindow';
import {setPopupWindow} from '../../common/events';
import * as types from '../types';

export function onSocialClick({url, label, intl, externalWindow, dispatch}) {
  if (typeof window !== 'undefined') {
    dispatch({type: types.LOGIN_ATTEMPT, user: {}});
    PushEvent('Social auth', {social: intl.messages[`socials.${label}`] || label});
    if (externalWindow) {
      setPopupWindow(open(url, 'auth', 1000, 800));
    } else {
      window.top.location.href = url;
    }
  }
}



// WEBPACK FOOTER //
// ./utils/socials.js